/**
 * Who is visiting: `/api/v1/me`, asked once per page. Pages are rendered the
 * same for everybody (no session or database work for page views), so the
 * header learns the login state here and swaps its [data-auth] items.
 */

import { getMe } from "./api/client";
import type { Me } from "./api/types";
import { findAll } from "./lib/dom";

let me: Promise<Me | null> | null = null;

/** The visitor (null when /api/v1/me cannot be read: treated as a free visitor). */
export function loadMe(): Promise<Me | null> {
  me ??= getMe().catch(() => null);
  return me;
}

export function isPremium(visitor: Me | null): boolean {
  return visitor?.premium === true;
}

/** Show the header items of the visitor's state (Sign In/Sign Up or My Account/Sign Out). */
function showAuthState(signedIn: boolean): void {
  for (const item of findAll(document, "[data-auth]", HTMLElement)) {
    item.hidden = item.dataset["auth"] !== (signedIn ? "user" : "guest");
  }
}

export async function initSession(): Promise<void> {
  const visitor = await loadMe();
  if (visitor !== null) showAuthState(visitor.account !== null);
}
